/* MMG v3.10.10 — Global CTA behavior owner · selector-gated dynamic normalization. */
(() => {
  'use strict';
  if (window.__MMG_GLOBAL_CTA_V3109__) return;
  window.__MMG_GLOBAL_CTA_V3109__ = true;
  const root = document.documentElement;
  const reduced = !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const selector = [
    'a.button','button.button','input.button','a[class*="button"]','button[class*="button"]',
    'a[class*="cta"]','button[class*="cta"]','a[class*="btn"]','button[class*="btn"]',
    'a.mmg-v32-next__link','a.mmg-v2-button','a.mmg-button','button.mmg-button',
    '.shopify-payment-button__button','product-form button[type="submit"]',
    'form[action*="/cart"] button[type="submit"]','[role="button"][class*="mmg-"]'
  ].join(',');
  const isDisabled = el => !!(el?.hasAttribute?.('disabled') || el?.getAttribute?.('aria-disabled') === 'true' || el?.classList?.contains('disabled'));
  function resolveSameDocumentTarget(anchor) {
    const raw = anchor.getAttribute('href') || '';
    if (!raw || raw === '#' || raw.startsWith('javascript:')) return null;
    let url; try { url = new URL(raw, location.href); } catch (_) { return null; }
    if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !url.hash) return null;
    let id = ''; try { id = decodeURIComponent(url.hash.slice(1)); } catch (_) { id = url.hash.slice(1); }
    if (!id) return null;
    return document.getElementById(id) || document.querySelector(`[name="${CSS.escape(id)}"]`);
  }
  function press(el) { if (!isDisabled(el)) el.classList.add('is-mmg-cta-pressed-v3109'); }
  function release(el) { el.classList.remove('is-mmg-cta-pressed-v3109'); }
  function normalizeAnchor(anchor) {
    if (anchor.target === '_blank') { const rel = new Set(String(anchor.rel || '').split(/\s+/).filter(Boolean)); rel.add('noopener'); rel.add('noreferrer'); anchor.rel = [...rel].join(' '); }
    anchor.addEventListener('click', event => {
      if (isDisabled(anchor)) return;
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || anchor.target === '_blank' || anchor.hasAttribute('download')) return;
      const target = resolveSameDocumentTarget(anchor); if (!(target instanceof HTMLElement)) return;
      event.preventDefault(); target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      const hash = anchor.getAttribute('href')?.split('#')[1]; if (hash) { try { history.replaceState(null, '', `#${hash}`); } catch (_) {} }
    });
  }
  function normalize(el) {
    if (!(el instanceof HTMLElement) || el.dataset.mmgCtaV3109 === 'true') return;
    el.dataset.mmgCtaV3109 = 'true'; el.dataset.mmgCtaOwner = 'v3.10.10-native-action';
    if (el instanceof HTMLAnchorElement) normalizeAnchor(el);
    el.addEventListener('pointerdown', () => press(el), { passive: true });
    ['pointerup','pointercancel','pointerleave','blur'].forEach(type => el.addEventListener(type, () => release(el), { passive: true }));
    el.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') press(el); });
    el.addEventListener('keyup', event => { if (event.key === 'Enter' || event.key === ' ') release(el); });
  }
  function apply(scope = document) {
    const target = scope?.querySelectorAll ? scope : document;
    if (target instanceof HTMLElement && target.matches(selector)) normalize(target);
    target.querySelectorAll?.(selector).forEach(normalize);
    root.dataset.mmgCtaGovernance = 'v3.10.10-selector-gated';
  }
  const containsCta=node=>node instanceof HTMLElement&&(node.matches(selector)||!!node.querySelector?.(selector));
  let queued = false, fullScan = false; const pendingScopes = new Set();
  function schedule(scope = document) {
    if (scope === document) { fullScan = true; pendingScopes.clear(); }
    else if (!fullScan && scope?.querySelectorAll) pendingScopes.add(scope);
    if (queued) return; queued = true;
    requestAnimationFrame(() => {
      queued = false;
      if (fullScan) { fullScan = false; pendingScopes.clear(); apply(document); return; }
      const scopes = [...pendingScopes]; pendingScopes.clear(); scopes.forEach(apply);
    });
  }
  function init() {
    apply(document);
    document.addEventListener('shopify:section:load', event => schedule(event.target));
    document.addEventListener('shopify:section:reorder', () => schedule(document));
    addEventListener('pageshow', () => schedule(document));
    if ('MutationObserver' in window && document.body) {
      new MutationObserver(mutations => mutations.forEach(mutation => mutation.addedNodes?.forEach(node => { if (containsCta(node)) schedule(node); }))).observe(document.body, { childList: true, subtree: true });
    }
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init, { once: true }) : init();
})();
